import { navLinks } from "@/mocks/content";

interface FooterProps {
  onSelectCategory: (key: string) => void;
}

const categories = [
  { key: "伦理片", label: "伦理片" },
  { key: "韩剧", label: "韩剧" },
  { key: "短剧", label: "短剧" },
  { key: "高分电影", label: "高分电影" },
];

export default function Footer({ onSelectCategory }: FooterProps) {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-heart-3-fill" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold">红桃影视</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-100/90">
              一份围绕平台片库整理的观影参考，覆盖最新影片、伦理片、韩剧、短剧与高分电影，帮你更快找到想看的片子。
            </p>
          </div>

          <div>
            <p className="font-label text-xs tracking-[0.2em] text-secondary-200 mb-4">
              内容板块
            </p>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <button
                    type="button"
                    onClick={() => onSelectCategory(cat.key)}
                    className="text-sm text-secondary-100 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-label text-xs tracking-[0.2em] text-secondary-200 mb-4">
              页面导航
            </p>
            <ul className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => jump(link.id)}
                    className="text-sm text-secondary-100 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-label text-xs tracking-[0.2em] text-secondary-200 mb-4">
              使用说明
            </p>
            <p className="text-sm leading-relaxed text-secondary-100/90">
              站内评分与热播榜仅用于帮助筛选，不代表唯一标准。整站内容为片单参考与题材说明，具体上线与更新以平台片目页为准。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-label text-xs text-secondary-200">
            © 2026 红桃影视片库指南 · 仅供观影方向参考
          </p>
          <p className="font-label text-xs text-secondary-300">
            内容持续整理中 · 每周更新片单
          </p>
        </div>
      </div>
    </footer>
  );
}